import { Component } from '@angular/core';

@Component({
standalone: false,
  selector: 'app-disabled-method-dialog',
  templateUrl: './disabled-method-dialog.component.html',
  styleUrls: ['./disabled-method-dialog.component.scss'],
})
export class DisabledMethodDialogComponent {}
